import apiService from "../common/commonApi";

export const workingHour = {};

workingHour.list = async (param) => {    
    return apiService.Get('worklog-list', param);
}

workingHour.add = async (param) => {    
    return apiService.Post('worklog-create', param);
}

workingHour.update = async (param) => {    
    return apiService.Post('worklog-update', param);
}

workingHour.delete = async (param) => {    
    return apiService.Post('worklog-delete', param);
}

workingHour.getApproval = async (param) => {    
    return apiService.Post('getapproval', param);
}
